@let branding = brandingService.branding$ | async;
@let authentication = authService.authentication$ | async;

@if (authentication && branding !== undefined && branding !== null) {
    <div class="micromate-learn">
        <div class="micromate-already-connected" *ngIf="alreadyConnected$ | async">
        <span
            class="micromate-already-connected-message">{{ 'general.alreadyConnected' | translate:{appName: branding.appName} }}</span>
            <button class="micromate-already-connected-button"
                    [attr.disabled]="actionInProgress ? true : null"
                    (click)="reconnect()">{{ 'general.useMicromateHere' | translate:{appName: branding.appName} }}
            </button>
        </div>

        <ng-container *ngIf="!(alreadyConnected$ | async) && isConnected">
            <router-outlet></router-outlet>
        </ng-container>
    </div>
}


